// Async function to get config //
import asyncConfig from "./../asyncConfig.js";

// const domain = process.env.VUE_APP_API_DOMAIN;
// const baseURL = process.env.VUE_APP_BASE_URL;

// const idpAuthority = "http://jbase.xtrdev.info/auth/realms/aceas-dev";

async function apiConfig() {
  const commonConfig = await asyncConfig.getCommonConfig();
  const data = commonConfig.data;
  const domain = data.apiBaseUrl;
  const version = data.version;
  // Add Wogaa script
  let s = document.createElement("script");
  let head = document.querySelector("head");
  s.type = "text/javascript";
  if (data.environment === "prd") {
    s.src = "https://assets.wogaa.sg/scripts/wogaa.js";
  } else {
    s.src = "https://assets.dcube.cloud/scripts/wogaa.js";
  }
  head.append(s);

  return {
    apiBaseUrl: domain,
    environment: data.environment,
    wogaaTrackingId: {
      eServices:
        data.wogaaTrackingId && data.wogaaTrackingId.eServices
          ? data.wogaaTrackingId.eServices
          : "",
      complaint:
        data.wogaaTrackingId && data.wogaaTrackingId.complaint
          ? data.wogaaTrackingId.complaint
          : ""
    },
    maintenanceInfo: data.maintenanceInfo,
    googleReCaptchaSiteKey: data.googleReCaptchaSiteKey,
    version,
    common_module: {
      commonConfig: {
        idpAuthority: data.idpAuthority,
        idpClientId: data.idpClientId,
        idpRedirectUri: data.idpRedirectUri,
        idpPostLogoutRedirectUri: data.idpPostLogoutRedirectUri,
        idpScope: data.idpScope,
        idpResponseType: data.idpResponseType,
        idpMaxAbsoluteSession: data.idpMaxAbsoluteSession,
        idpBeforeAbsoluteSessionNotificationTime:
          data.idpBeforeAbsoluteSessionNotificationTime,
        idpSessionIdleTime: data.idpSessionIdleTime,
        idpSilentReqTimeout: data.idpSilentReqTimeout,
        idpSilentRedirectUri: data.idpSilentRedirectUri,
        idpAccessTokenExpiringNotificationTime: 30,
        googleSearchId: data.googleSearchId,
        idpRenewAccessTokenMs: data.idpRenewAccessTokenMs
      },
      templateManagement: {
        getTemplateByKeyEndpoint:
          domain +
          "/aceas/api/internet/template/v1/templates/public/prompts/getByKey"
      },
      documentManagement: {
        getEndpointSmallUpload:
          domain + "/aceas/api/internet/doc/v1/file/upload-small",
        getDownloadUsingPresignedUrl:
          domain + "/aceas/api/internet/doc/v1/file/download-use-presigned-url"
      },
      permissions: {
        getPermissionEndpoint:
          domain + "/aceas/api/internet/permission/v1/user-permissions"
      },
      examManagement: {
        getHasExamStatus:
          domain + "/aceas/api/internet/exam/v1/workspace/getHasExamStatus"
      },
      profileManagement: {
        getProfileBySgid:
          domain + "/aceas/api/internet/profile/v2/profiles/sgId",
        getOverviewData:
          domain + "/aceas/api/internet/profile/v2/profiles/overview",
        getHasProfileValidationEndpoint:
          domain + "/aceas/api/internet/profile/v2/profiles/validate",
        getProfileInfo: domain + "/aceas/api/internet/profile/v2/profileInfo",
        getPublicRegisterFilterEndpoint:
          domain + "/aceas/api/internet/profile/v2/public-register/filter"
      },
      qualificationManagement: {
        getHasAQStatusEndpoint:
          domain + "/aceas/api/internet/qualification/v1/assessment/filter",
        getCPDCPFStatus:
          domain + "/aceas/api/internet/qualification/v1/qualification/cpdcpf"
      },
      appManagement: {
        getNewReturningAggregateCountEndpoint:
          domain +
          "/aceas/api/internet/app/res/v1/resRegNewReturnApp/aggregate/count",
        getIncomingSwitchingAggregateCountEndpoint:
          domain +
          "/aceas/api/internet/app/res/v1/resRegSwitching/aggregate/incoming/count",
        getOutgoingSwitchingAggregateCountEndpoint:
          domain +
          "/aceas/api/internet/app/res/v1/resRegSwitching/aggregate/outgoing/count",
        getRenewalAggregateCountEndpoint:
          domain +
          "/aceas/api/internet/app/renewal/v1/resRegRenewal/aggregate/count",
        getCountPendingSubmissionSwitchingIncomingEndpoint:
          domain +
          "/aceas/api/internet/app/res/v1/resRegSwitching/countIncomingPendingEASubmission",
        getCountPendingResubmissionSwitchingIncomingEndpoint:
          domain +
          "/aceas/api/internet/app/res/v1/resRegSwitching/countIncomingPendingEAResubmission",
        getCountPendingEAConfirmationOutgoingEndpoint:
          domain +
          "/aceas/api/internet/app/res/v1/resRegSwitching/countPendingCurrentEAConfirmation",
        getCountPendingSubmissionNewReturnEndpoint:
          domain +
          "/aceas/api/internet/app/res/v1/resRegNewReturnApp/countPendingEASubmission",
        getCountPendingResubmissionNewReturnEndpoint:
          domain +
          "/aceas/api/internet/app/res/v1/resRegNewReturnApp/countPendingEAResubmission",
        getDirectorPartnerListing:
          domain +
          "/aceas/api/internet/app/ea/v1/eaLicAddRmvDpApp/filterApplicationAddition",
        getCheckRenewalPeriodEndpoint:
          domain + "/aceas/api/internet/app/res/v1/appGeneral/getRenewalPeriod",
        getGeneralActiveApplicationsEndpoint:
          domain +
          "/aceas/api/internet/app/res/v1/appGeneral/getLatestActiveApplications",
        getGeneralDraftApplicationsEndpoint:
          domain +
          "/aceas/api/internet/app/res/v1/appGeneral/getLatestDraftApplications",
        getRenewalInitiationEndpoint:
          domain + "/aceas/api/internet/app/renewal/v1/resRegRenewal/initiate",
        getNonRenewalInitiationEndpoint:
          domain +
          "/aceas/api/internet/app/renewal/v1/resRegNonRenewal/initiate",
        getEARenewalInitiationEndpoint:
          domain +
          "/aceas/api/internet/app/renewal/v1/eaLicRenewal/renewal/init",
        getDPRenewalListEndpoint:
          domain +
          "/aceas/api/internet/app/renewal/v1/eaLicRenewal/renewal/dp/filter",
        getEAEligibilityEndpoint:
          domain +
          "/aceas/api/internet/app/renewal/v1/eaLicRenewal/renewal/init/eligible",
        getEANonRenewalEligibilityEndpoint:
          domain +
          "/aceas/api/internet/app/renewal/v1/eaLicRenewal/nonRenewal/eligible",
        getRESNonRenewalEligibilityEndpoint:
          domain +
          "/aceas/api/internet/app/renewal/v1/resRegNonRenewal/init/eligibleNonRenewal",
        getRESEligibilityEndpoint:
          domain +
          "/aceas/api/internet/app/renewal/v1/resRegRenewal/init/eligible",
        getPreAppActiveApplications:
          domain +
          "/aceas/api/internet/app/res/v1/preAppAssess/getActiveApplications",
        getRecommendationDataOnNewReturning:
          domain +
          "/aceas/api/internet/app/res/v1/resRegNewReturnApp/recommendationData",
        getRecommendationDataOnAdditionDP:
          domain +
          "/aceas/api/internet/app/ea/v1/eaLicAddRmvDpApp/recommendationData",
        getRecommendationDataOnSwitching:
          domain +
          "/aceas/api/internet/app/res/v1/resRegSwitching/recommendationData",
        getRecommendationDataOnResRenewal:
          domain +
          "/aceas/api/internet/app/renewal/v1/resRegRenewal/recommendationData",
        getCountRESRenewalEASubmission:
          domain +
          "/aceas/api/internet/app/renewal/v1/resRegRenewal/countPendingEASubmission",
        getCountRESRenewalEAResubmission:
          domain +
          "/aceas/api/internet/app/renewal/v1/resRegRenewal/countPendingEAResubmission"
      },
      eaLicenceRenewal: {
        dp: {
          canSubmit:
            domain +
            "/aceas/api/internet/app/renewal/v1/eaLicRenewal/renewal/dp/isAvailableSubmit"
        }
      }
    }
  };
}

export default apiConfig;
